const PATH = {
    LOGIN: '/login',
    VOTACAO: '/votacao',
    SECOES: '/secoes',
    ACOMPANHAMENTO: '/acompanhamento',
    MAPA: '/mapa',
    PENDENCIAS: '/pendencias',
    ERROR500: '/error500'
}

export default PATH